import React from 'react';
import { css } from 'react-emotion';
import { components, elements, colors } from '@peachjar/components';

import {
  PRESS_RELEASE_TEMPLATE_LINK,
  SOCIAL_MEDIA_TEMPLATE_LINK,
  GEOCORE_LOGIN_LINK,
  COMMUNITY_PARTNERS_LIST_TEMPLATE_LINK,
} from '../constants';

const {
  Buttons: { ButtonPrimaryLarge, ButtonSecondarySmall },
} = components;

const { Headline2, Paragraph } = elements.typography;

const styles = {
  paddingTop: css`
    padding-top: 2rem;
  `,
};

const WhileYouWait = () => (
  <div
    style={{
      backgroundColor: 'white',
      padding: '3rem',
      borderRadius: '3px',
    }}
  >
    <Headline2 className="mb-3">While you wait...</Headline2>

    <p className="mb-2">
      <Paragraph>
        Download the template below to compile a list of your organizations to
        send to Peachjar.
      </Paragraph>
    </p>

    <a href={COMMUNITY_PARTNERS_LIST_TEMPLATE_LINK}>
      <ButtonSecondarySmall>Download Template</ButtonSecondarySmall>
    </a>

    <div className={styles.paddingTop}>
      <div className="mb-4">
        <Paragraph>
          Your community is about to go paperless with Peachjar! We have
          prepared the following templates to help guide you as you share this
          important new change.
        </Paragraph>
      </div>
      <div className="mb-4">
        <p className="mb-2">
          <Paragraph>Press Release Template</Paragraph>
        </p>

        <a href={PRESS_RELEASE_TEMPLATE_LINK}>
          <ButtonSecondarySmall>Download Template</ButtonSecondarySmall>
        </a>
      </div>

      <div className="mb-4">
        <p className="mb-2">
          <Paragraph>Social Media Template</Paragraph>
        </p>

        <a href={SOCIAL_MEDIA_TEMPLATE_LINK}>
          <ButtonSecondarySmall>Download Template</ButtonSecondarySmall>
        </a>
      </div>
    </div>

    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: '1rem',
        marginRight: '1rem',
      }}
    >
      <Paragraph>
        We also opened the Peachjar platform for you to start exploring while
        you wait to go live.
      </Paragraph>

      <a href={GEOCORE_LOGIN_LINK} rel="noopener noreferrer" target="_blank">
        <ButtonPrimaryLarge>Start Exploring</ButtonPrimaryLarge>
      </a>
    </div>
  </div>
);

export default WhileYouWait;



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/confirm/components/WhileYouWaitTab.jsx